<template class="blue">
    <div class="main">
        <!--Filter-->
        <v-container fluid class="pa-0" max-width="500">
            <v-card class="d-flex ml-2 pt-2 pb-0 flex-row" outlined>
                <v-form class="slim">
                    <v-container class="d-flex ml-2 pt-2 flex-row flex-wrap">
                        <v-text-field class="pr-3 mx-240"
                                      v-model="filter.fldTNombre"
                                      label="Nombre"
                                      v-on:keyup.enter="loadData" 
                                      outlined
                                      clearable
                                      dense></v-text-field>
                        <v-text-field class="pr-3 mx-240"
                                      v-model="filter.fldTRuta"
                                      label="Ruta"
                                      v-on:keyup.enter="loadData" 
                                      outlined
                                      clearable
                                      dense></v-text-field>
                        <v-card-actions class="btns-float">
                            <v-btn color="grey" @click="clearFilter" small>Limpiar</v-btn>
                            <v-btn color="accent" dark small @click="loadData">Filtrar</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-form>
            </v-card>
        </v-container>

        <!--Buttons-->
        <v-container class="pb-3 ml-1 mb-3">
            <v-btn color="accent" small dark @click="addItem">Agregar Imagen</v-btn>
            <v-btn small color="accent" dark class="ml-5" @click="exportPDF">
                PDF <v-icon dark right>mdi-adobe-acrobat</v-icon>
            </v-btn>
            <v-btn small color="accent" class="ml-5" dark @click="exportExcel">
                Excel <v-icon dark right>mdi-file-excel-outline</v-icon>
            </v-btn>

        </v-container>

        <!--NewForm-->
        <v-dialog persistent v-model="nuevoForm" max-width="480">
        <v-card class="mx-auto">
            <v-toolbar color="blue" dark>
                <v-toolbar-title>Agregar Imagen</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-form ref="formularioNuevo" class="slim">
                <v-container>
                    <v-row no-gutters>
                        <v-col justify="center" align="center">
                            <v-text-field class="pl-3 pt-3 pr-3" v-model="image.fldTNombre" label="Nombre" outlined :rules="nameRules" dense></v-text-field>
                            <v-file-input class="pl-3 pt-3 pr-3" v-model="image.image" accept=".png,.ico,.jpg,.svg" label="Seleccione una imagen" :rules="fileRules" append-icon="mdi-camera" prepend-icon="" dense outlined></v-file-input>
                            <template v-if="imageb64 && image.image">
                                <img :src="imageb64" style="max-width: 100px; max-height: 100px;" />
                            </template>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions class="justify-space-between w-100 pb-6">
                    <v-spacer></v-spacer>
                    <v-btn text small @click="nuevoForm = false">
                        cancelar
                    </v-btn>
                    <v-btn color="blue" dark small @click="saveData">
                        Guardar
                    </v-btn>
                </v-card-actions>

            </v-form>

        </v-card>
    </v-dialog>
        <!--EditForm-->
        <template>
        <v-row justify="center">
            <v-dialog persistent v-model="editForm" max-width="480">
                <v-card class="mx-auto">
                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>Editar Imagen</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-form ref="formularioEdicion" class="slim">
                        <v-container>
                            <v-row no-gutters>
                                <v-col justify="center" align="center">
                                    <v-text-field class="pl-3 pt-3 pr-3" v-model="image.fldTNombre" label="Nombre" outlined :rules="nameRules" dense :disabled="puedeCambiar == false"></v-text-field>
                                    <v-file-input class="pl-3 pt-3 pr-3" v-model="image.image" accept=".ico,.jpg,.png,.svg" label="Seleccione una imagen" append-icon="mdi-camera" prepend-icon="" dense outlined :disabled="puedeCambiar == false"></v-file-input>
                                    <template v-if="imageb64">
                                        <img :src="imageb64" style="max-width: 100px; max-height: 100px;" />
                                    </template>
                                    <template v-else>
                                        <img :src="image.path" style="max-width: 100px; max-height: 100px;" />
                                    </template>
                                </v-col>
                            </v-row>
                        </v-container>
                            <v-card-actions class="justify-space-between w-100 pb-6">
                                <v-btn class="ma-2" dark small color="red" @click="deleteItem">
                                    <v-icon left>mdi-delete</v-icon> Borrar registro
                                </v-btn>
                                <div class="justify-right">
                                    <v-btn class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                        Cancelar
                                    </v-btn>
                                    <v-btn v-if="puedeCambiar == false" class="ma-2" dark small color="success" @click="puedeCambiar = true">
                                        <v-icon left>mdi-pencil</v-icon> Editar
                                    </v-btn>
                                    <v-btn v-else class="ma-2" dark small color="success" @click="saveData">
                                        <v-icon left>mdi-pencil</v-icon> Guardar
                                    </v-btn>
                                </div>
                            </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-row>
    </template>
        <!--Table-->
        <v-container fluid class="py-0">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-card>
                        <v-data-table dense :headers="headers" :items="images" item-key="idNIcon" :footer-props="{
                        'items-per-page-options': [5, 10, 20, 50]}" class="elevation-1 gt slim">
                            <template v-slot:item.imagen="{item}">
                                <img :src="item.icono" style="max-width: 30px; max-height: 30px;" >
                            </template>
                            <template v-slot:item.ico1="{ item }">
                                <v-chip :color="item.ico1" dark label></v-chip>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon color="green" @click="editItem(item)">
                                    mdi-pencil
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <confirm ref="confirmDialog">
        </confirm>
    </div>
</template>
<script>
    import { Component, Prop, Vue } from "vue-property-decorator";
    import IconService from "../services/IconService";
    import IconModel from "../models/IconModel";
    import Confirm from '../components/ConfirmDelete';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';

    @Component({
        components: {
            Confirm
        },
        mounted: async function () {
            await this.loadData();
        },
        watch: {
            image: {
                handler: async function (newInfo, oldInfo) {
                    console.log(newInfo);

                    if (newInfo.type == "image/svg+xml") {
                        newInfo.type = "image/svg";
                    }
                    if (newInfo.image) {
                        this.$data.imageb64 = await this.toBase64(newInfo.image);
                    } else {
                        this.$data.imageb64 = null;
                    }
                },
                deep: true
            }
        },
        methods: {
            
            loadData: async function () {
                try {
                    var resI = await new IconService().list(this.filter);
                    if (resI.success) {
                        var data = resI.data;
                        var version = new Date().getTime();
                        data.forEach(function (i) {
                            i.icono = i.fldTRuta + "?version=" + version;
                        });
                        this.$data.images = data;
                    }
                    else {
                        this.showError('Ocurrio un error: ' + resI.Message);
                    }  

                } catch (e) {
                    console.log(e);
                }
            },
            clearFilter: async function () {
                this.filter = new IconModel();
                this.loadData();
            },
            chkBotonCancelar() {
                // Estoy editando y presiono cancelar
                if (this.$data.puedeCambiar == true && this.$data.editForm == true) {
                    this.$data.image = JSON.parse(JSON.stringify(this.$data.imageAux));
                    this.$data.image.path = this.$data.image.fldTRuta;
                    this.$data.imageb64 = this.$data.imageb64Aux;
                    this.$data.puedeCambiar = false;
                } else {
                    this.closeDialog();
                }
            },
            closeDialog() {
                this.$data.editForm = false;
                this.$data.puedeCambiar = false;
                this.$data.image = new IconModel();
                this.$data.imageAux = new IconModel();
            },
            saveData: async function () {
                try {
                    
                    let model = new IconModel();
                    model.fldTNombre = this.$data.image.fldTNombre;

                    var uService = new IconService(this.filter);
                    var data = null;
                    
                    if (this.$data.image.idNIcono) {
                        // Edicion
                        if (!this.$refs.formularioEdicion.validate()) {
                            return;
                        }

                        model.idNIcono = this.$data.image.idNIcono;

                        // Si al editar cargo un nuevo archivo
                        if (this.$data.imageb64 != this.$data.imageb64Aux) {
                            model.fldTRuta = this.$data.imageb64;
                        } else {
                            model.fldTRuta = "";
                        }
                        
                        data = await uService.update(model);
                    } else {
                        // ALTA
                        if (!this.$refs.formularioNuevo.validate()) {
                            console.log("nuevio");
                            return;
                        }

                        model.fldTRuta = this.$data.imageb64;
                        data = await uService.insert(model);
                    }
                    
                    if (data.success) {                        
                         //Deber�a limpiar el LocalStorage-Para que se llene de la vista necesite.
                        localStorage.removeItem("IconsAll");

                        this.nuevoForm = false;
                        this.closeDialog();
                        this.loadData();
                       
                       
                        this.showSuccess('El registro fue guardado correctamente');
                    } else {
                        this.showError('Ocurrio un error al guardar el registro: ' + data.ex.Message);
                    }
                } catch (e) {
                    console.log(e);
                }
            },
            async editItem(item) {
                this.$data.image = JSON.parse(JSON.stringify(item));
                this.$data.imageAux = JSON.parse(JSON.stringify(item));
                this.$data.image.path = item.icono;
                this.$data.imageb64Aux = this.$data.imageb64;
                this.$data.editForm = true;
            },
            addItem: async function () {
                this.$data.image = new IconModel();
                this.$data.imageb64 = null;
                this.$data.imageb64Aux = null;
                this.$data.nuevoForm = true;
            },
           async toBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            },
            async deleteItem() {
                var ret = await this.$refs.confirmDialog.showDialog();
                if (ret == true) {
                    var data = await new IconService().delete(this.$data.image);
                    if (data.success) {
                        this.showSuccess('El registro fue eliminado correctamente');
                        //Deber�a limpiar el LocalStorage-Para que se llene de la vista necesite.
                        localStorage.removeItem("IconsAll");
                        this.loadData();
                    } else {
                        this.showError('Ocurrio un error borrando el registro: ' + data.error);
                    }
                }
                this.closeDialog();
            },
            async exportExcel() {
                var data = await new IconService().export(this.filter);

                var fileURL = window.URL.createObjectURL(data);
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Imagenes.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();


            },
            // TODO: Analizar cual de las 2 funciones va a quedar
            toDataUrl(url, callback) {
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        callback(reader.result);
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            },
            convertImgToBase64(url, callback, outputFormat) {
                
                var canvas = document.createElement('CANVAS');
                var ctx = canvas.getContext('2d');
                var img = new Image();
                img.crossOrigin = 'Anonymous';
                img.onload = function () {
                    canvas.height = img.height;
                    canvas.width = img.width;
                    ctx.drawImage(img, 0, 0);
                    var dataURL = canvas.toDataURL(outputFormat || 'image/png');
                    console.log(dataURL);
                    callback.call(this, dataURL);
                    console.log(dataURL);
                    // Clean up
                    canvas = null;
                };
                
                img.src = url;
            },
            // TODO: mostrar las imagenes en el PDF
            exportPDF() {
                var doc = new jsPDF();
                var title = 'Imagenes';
                var columns = [
                    //{ title: 'Id', dataKey: 'idNIcono' },
                    { title: 'Nombre', dataKey: 'fldTNombre' },
                    { title: 'Ruta', dataKey: 'fldTRuta' }];
                doc.text(title, 15, 10);
                //doc.addImage("https://localhost:44316/images/uploads/Nuevo.jpg", "JPEG", 15, 40, 180, 180);

                var datos = JSON.parse(JSON.stringify(this.$data.images));
                var self = this;
                datos.forEach(async function (d) {
                    await self.toDataUrl("https://localhost:44316/images/uploads/Nuevo.jpg", function (myBase64) {
                        d.fldTRuta = myBase64;
                    });

                    /*self.convertImgToBase64("https://localhost:44316/images/uploads/Nuevo.jpg", function (res) {
                        console.log(res);
                    });*/
                       
                });
                //console.log(datos);
                doc.autoTable(columns, datos,
                    {
                        didDrawCell: async function (data) {
                            if (data.column.index === 2 && data.section === 'body') {
                                //console.log(data.row)
                                //console.log(data.cell.raw);
                                var dim = data.cell.height - data.cell.padding('vertical');
                                var textPos = data.cell.textPos;
                                //doc.addImage(data.cell.raw,'PNG', textPos.x, textPos.y, 30, 30);
                                //doc.addImage(img, textPos.x, textPos.y, 30, 30);
                            }
                        }
                    });
                doc.save(title + '.pdf');
            }


        }
    })

    export default class Imagenes extends Vue {
        nuevoForm = false;
        editForm = false;
        puedeCambiar = false;
        formularioNuevo = true;
        formularioEdicion = true;

        // Models
        image = new IconModel();
        imageAux = new IconModel();
        filter = new IconModel();

        imageb64 = null;
        imageb64Aux = new IconModel();

        // Lists
        images = [];

        headers = [
            { text: '', value: 'ico1', sortable: false, width: '10px' },
            { text: '', value: 'action', sortable: false, width: '10px' },
            { text: 'Imagen', value:'imagen', sorteable:false, width:'80px'},
            { text: 'Nombre', value: 'fldTNombre',width:'300px' },
            { text: 'Ruta', value: 'fldTRuta' },
        ];

        nameRules = [
            v => !!v || 'Debe ingresar un nombre',
            v => v && v.length <= 250 || 'El nombre tiene que contener menos de 250 caracteres',
        ];


        fileRules = [
            v => !!v || 'Debe seleccionar un archivo',
        ];

    }
</script>